import { render, staticRenderFns } from "./ThreadRow.vue?vue&type=template&id=90141ad4&scoped=true"
import script from "./ThreadRow.vue?vue&type=script&lang=js"
export * from "./ThreadRow.vue?vue&type=script&lang=js"
import style0 from "./ThreadRow.vue?vue&type=style&index=0&id=90141ad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90141ad4",
  null
  
)

export default component.exports